import { render, staticRenderFns } from "./CustomSlideDeckOptions.modal.vue?vue&type=template&id=6205ea2e&scoped=true"
import script from "./CustomSlideDeckOptions.modal.vue?vue&type=script&lang=ts"
export * from "./CustomSlideDeckOptions.modal.vue?vue&type=script&lang=ts"
import style0 from "./CustomSlideDeckOptions.modal.vue?vue&type=style&index=0&id=6205ea2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6205ea2e",
  null
  
)

export default component.exports